import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Avatar,
  Typography,
  IconButton,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import StarIcon from "@mui/icons-material/Star";
import { motion } from "framer-motion";
import { EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT } from "../../constants/AzureDevops";

export default function GoogleReviews(props) {
  const { isSmallScreen, city,course } = props;

  const reviews = [
    {
      name: "Ayush Yadav",
      date: "February 12, 2025",
      review:
        `Starting with PaperLive Learning for DevOps training ${city ? `in ${city}` : ""} was a great move. The course provided a perfect blend of informative lessons and practical exercises, which sharpened my skills and boosted my confidence.`,
      image:
        "https://lh3.googleusercontent.com/a-/ALV-UjVVfCo87trLkVxAjy1pfkwkSydVEL3hmxR0eLUhJ8Lz7pgJK6g9=w45-h45-p-rp-mo-br100",
    },
    {
      name: "Chitraksh Srivastava",
      date: "February 18, 2025",
      review:
        `The DevOps Course ${city ? `in ${city}` : ""} from PaperLive is absolutely the best. Their service, syllabus, and trainer are outstanding, and the course exceeded my expectations.`,
      image:
        "https://lh3.googleusercontent.com/a/ACg8ocIjyQqKwwONs-Pg3JyYsGksiZaZvSiYB_QW52yjiVHBEFZ-Xw=w45-h45-p-rp-mo-br100",
    },
    {
      name: "Harshita Srivastava",
      date: "March 2, 2025",
      review:
        `The DevOps course ${city ? `in ${city}` : ""} at PaperLive exceeded my expectations and helped me secure a great job opportunity. The teachers made learning engaging and practical.`,
      image:
        "https://lh3.googleusercontent.com/a-/ALV-UjVq9eRuMVxJl8M1XEs-yeIDzANRY6CvlwdcKfF4AR8oe3XxMj7qyQ=w45-h45-p-rp-mo-br100",
    },
    {
      name: "Lakshmi Narayan",
      date: "March 10, 2025",
      review:
        "PaperLive Learning stands out because of its excellent course material and extraordinary staff support. The skills I learned were crucial in achieving my career goals.",
      image:
        "https://lh3.googleusercontent.com/a/ACg8ocIzhGbE5jRbM2WYvnnmnTLibBOnqWbDBJLfpbzmSNlzDTC7dg=w45-h45-p-rp-mo-br100",
    },
    {
      name: "Shivnandan Kumar",
      date: "March 18, 2025",
      review:
        `Choosing PaperLive Learning for DevOps training ${city ? `in ${city}` : ""} was the right decision. The hands-on approach and knowledgeable trainers greatly improved my confidence.`,
      image:
        "https://lh3.googleusercontent.com/a-/ALV-UjXZETudmffy2c5Z2f_WTfMKu42DfNfzzlsmLn0AJJZx9L89Ifwx=w45-h45-p-rp-mo-br100",
    },
    {
      name: "Sai Cherry",
      date: "March 25, 2025",
      review:
        "As a fresher, the DevOps and Multi-Cloud course at PaperLive Learning gave me the right skills and confidence through high-quality training and real-time projects.",
      image:
        "https://lh3.googleusercontent.com/a-/ALV-UjXUmGtU9nwxqfqMJsvs7rMb_1rJzos6yy5AX1yEloVPDBlG-DQ=s40-c-rp-mo-br100",
    },
  ];
  const [index, setIndex] = useState(0);
  const visible = isSmallScreen ? 1 : 3;

  const handleNext = () => {
    setIndex((prev) => (prev + visible >= reviews.length ? 0 : prev + visible));
  };

  const handlePrev = () => {
    setIndex((prev) =>
      prev - visible < 0 ? reviews.length - visible : prev - visible
    );
  };

  const handleDotClick = (dotIndex) => {
    setIndex(dotIndex * visible);
  };

  const truncate = (text, limit) =>
    text.length > limit ? text.substring(0, limit) + "..." : text;

  return (
    <Box
      sx={{
        width: { xs: "70%", md: "70%" },
        mx: "auto",
        mt: course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT ? 10 : 0,
        textAlign: "center",
        position: "relative",
      }}
    >
      <Typography variant={isSmallScreen ? "h4" :"h3"} fontWeight="bold" mb={4} textAlign={"left"}>
        Google Reviews
      </Typography>

      <IconButton
        aria-label="Previous Reviews"
        onClick={handlePrev}
        sx={{
          position: "absolute",
          left: -50,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 10,
          bgcolor: "#fff",
          boxShadow: 2,
        }}
      >
        <ArrowBackIosNewIcon />
      </IconButton>

      <Box
        component={motion.div}
        key={index}
        initial={{ x: 80, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 3,
        }}
      >
        {reviews.slice(index, index + visible).map((r, i) => (
          <Card
            onClick={() => window.open("https://www.google.com/maps/place/PaperLive+Learning/@12.8820947,77.7528114,17z/data=!4m8!3m7!1s0x3bae73c7913df275:0xc3c282779cad685e!8m2!3d12.8820947!4d77.7528114!9m1!1b1!16s%2Fg%2F11w7jfdb6w?entry=ttu&g_ep=EgoyMDI0MDkxNS4wIKXMDSoASAFQAw%3D%3D", "_blank")}
            key={i}
            sx={{
              flex: "1 1 30%",
              borderRadius: 3,
              textAlign: "left",
              p: 2,
              height: 300,
              boxShadow:
                "0 4px 12px rgba(0,0,0,0.08), inset 0px 0px 0px 1px rgba(255,255,255,0.1)",
              background: "linear-gradient(180deg, #fff, #f7f8fa)",
              cursor: "pointer",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Avatar src={r.image} alt={r.name} sx={{ width: 48, height: 48, mr: 2 }} />
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="subtitle1" fontWeight={700}>
                  {r.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {r.date}
                </Typography>
              </Box>
              <img
                loading="lazy"
                src="https://pbs.twimg.com/media/HER1QOYakAAm3Cl.jpg"
                alt="Google"
                width={40}
              />
            </Box>

            <Box sx={{ color: "#fbbc04", mb: 1 }}>
              {[...Array(5)].map((_, idx) => (
                <StarIcon key={idx} fontSize="small" />
              ))}
            </Box>

            <Typography variant="body2" color="text.secondary">
              {truncate(r.review, 240)}
            </Typography>
          </Card>
        ))}
      </Box>

      <IconButton
        aria-label="Next Reviews"
        onClick={handleNext}
        sx={{
          position: "absolute",
          right: -50,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 10,
          bgcolor: "#fff",
          boxShadow: 2,
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>

      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        {Array.from({ length: Math.ceil(reviews.length / visible) }).map((_, dotIndex) => (
          <Box
            key={dotIndex}
            onClick={() => handleDotClick(dotIndex)}
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              bgcolor: dotIndex === Math.floor(index / visible) ? "#000" : "#ccc",
              mx: 0.5,
              cursor: "pointer",
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
